import  { useEffect, useState } from 'react';

function PageTitle() {
    const [text] = useState("Angel Luján");
    useEffect(()=>{
        document.title = text;
    },[text])

}

export default PageTitle;